import * as FileSaver from "file-saver"
import React from 'react'
import * as XLSX from "xlsx"
import Button from '../../../components/UI/Button/Button'
import Search from '../../../components/UI/Search/Search'
import Select from '../../../components/UI/Select/Select'
import FetchData from '../../../shared/fetchData'
import './LockerStatusReports.css'

const LockerStatusReports = (props) => {

    const [from, setFrom] = React.useState('')
    const [to, setTo] = React.useState('')
    const [kiosk, setKiosk] = React.useState('')
    const [locker, setLocker] = React.useState('')
    const [kiosks, setKiosks] = React.useState([])
    const [lockers, setLockers] = React.useState([])
    const [rerender, setRerender] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [notLockerStatusReports, setLockerStatusReports] = React.useState([])
    const [isActive, setIsActive] = React.useState('')
    const [statusList, setStatusList] = React.useState([
        {
            value: "1",
            label: "فعال",
        },
        {
            value: "0",
            label: "غير فعال",
        }
    ])

    React.useEffect(() => {
        var raw = JSON.stringify({
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kiosks/getKiosks'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setKiosks(result.kiosks)
                }
            })
            .catch(error => console.log(error))
    }, [])

    const changeKiosk = selectedOption => {
        setKiosk(selectedOption);
        var raw = JSON.stringify({
            locker: {
                kiosk: {
                    id: selectedOption.value
                }
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/lockers/getLockers'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setLockers(result.lockers)
                }
            })
            .catch(error => console.log(error))
    }

    const changeLocker = selectedOption => {
        setLocker(selectedOption)
    }
    const changeStatus = selectedOption => {
        setIsActive(selectedOption)
    }

    const refresh = (event) => {
        setKiosk('')
        setLocker('')
        setIsActive('')
        setRerender(!rerender);
    }

    const exportToCSV = (event) => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "locker": {
                "id": locker != null && locker != "" ? locker.value : null,
                "kiosk": {
                    "id": kiosk != null && kiosk != "" ? kiosk.value : null,
                },
                "isActive": isActive != null && isActive != "" ? isActive.value : null,
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/lockers/getLockerStatusReports'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportOrderReport = []
                    let count = 0
                    const orderReport = result.lockers.map(o => {
                        count++
                        exportOrderReport.push({
                            'ردیف': count,
                            'نام لاکر': o.kiosk != null ? o.kiosk.description : '',
                            'شناسه باکس': o.serial,
                            "وضعيت": o.isActive != null && o.isActive == "1" ? "فعال است" : "فعال نيست",
                            "تاریخ اخذ گزارش": o.reportDate,
                            "ساعت اخذ گزارش": o.reportTime,
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportOrderReport);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'LockerStatusReports' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }
    const kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        kiosks.map(z => {
            kioskList.push({
                value: z.id,
                label: z.description
            })
        })
    }
    const lockerList = []
    if (lockers != null && lockers.length != 0) {
        lockers.map(z => {
            lockerList.push({
                value: z.id,
                label: z.serial
            })
        })
    }
    let form = <div>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            <div className="col-3 p-0 small-ord-col">
                <Select
                    name="form-field-name"
                    value={kiosk}
                    placeholder="لاکر"
                    options={kioskList}
                    onChange={changeKiosk}
                />
            </div>
            <div className="col-3 p-0 small-ord-col">
                <Select
                    name="form-field-name"
                    value={locker}
                    placeholder="باکس"
                    options={lockerList}
                    onChange={changeLocker}
                />
            </div>
            <div className="col-3 p-0 small-ord-col">
                <Select
                    name="form-field-name"
                    value={isActive}
                    placeholder="وضعيت"
                    options={statusList}
                    onChange={changeStatus}
                />
            </div>
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-6 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
        </div>
    </div>
    return (
        <div className="third-notLockerStatusReports">
            <Search class="orders-search" form={form} />
        </div>
    )
}
export default LockerStatusReports